import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

import { Column, TableProps } from '@/components/table/types';
import { cn } from '@/utils/classname';

interface Props<TData> {
  column: Column<TData>;
  sort: TableProps<TData>['sort'];
}

export function SortColumn<TData>({ column, sort }: Props<TData>) {
  if (!sort) {
    return null;
  }

  const isCurrentColumn = column.id === sort.orderBy;
  const isDescending = sort.descending;

  // Visual indicator only - click handling is done by Th element
  return (
    <div className="flex flex-col items-center">
      {isCurrentColumn && isDescending ? (
        <ChevronDownIcon
          className={cn(
            'text-chariot-text-primary size-4 shrink-0 cursor-pointer'
          )}
          data-testid="sort-icon-down"
        />
      ) : (
        <ChevronUpIcon
          className={cn(
            'text-chariot-text-primary size-4 shrink-0 cursor-pointer',
            !isCurrentColumn && 'hidden group-hover:block'
          )}
          data-testid="sort-icon-up"
        />
      )}
    </div>
  );
}
